<template>
  <nav class="w-full md:h-24 h-16 ">
    <div
      v-if="false"
      class="lg:px-12  px-4 h-full   mx-auto flex justify-between items-center sticky z-40 shadow-menu shimmer"
    >
      <div class="z-30 flex flex-wrap justify-between  items-center">
        <div class="shimmer-box  h-14 mx-2 md:px-8 px-4 text-transparent">text12 text</div>
        <div class="shimmer-box  h-14 mx-2 md:px-8 px-4 text-transparent">text12 text</div>

        <div class="relative hidden md:block ml-2 shimmer-box h-14 px-0 pr-16 lg:pr-5 lg:w-80 md:pr-5 md:w-52"></div>
      </div>
      <div class="md:order-2 logo z-40">
        <div class="shimmer-box w-24 h-12 mx-1 rounded-md"></div>
      </div>
      <div class="md:ml-auto hidden md:block">
        <ul
          id="menu"
          class="flex space-x-4"
          dir="rtl"
        >
          <li class="shimmer-box w-32 h-8 rounded mx-2"></li>
          <li class="shimmer-box w-32 h-8 rounded mx-2"></li>
        </ul>
      </div>
    </div>
    <div
      v-else
      class="lg:px-12 px-4 h-full mx-auto flex justify-between items-center sticky z-40 shadow-menu"
    >
      <div class="z-30">
        <div class="flex flex-wrap justify-between items-center">
          <auth-actions />
          <!--end Dropdown menu -->
          <div class="flex justify-center">
            <div class="relative hidden md:block ml-2">
              <!-- This is an example component -->
              <SearchView />
            </div>
          </div>
        </div>
      </div>
      <!-- Logo Here -->
      <div class="md:order-2 logo z-40">
        <router-link to="/" class="">
          <img
            src="@/assets/logo-1.webp"
            class="ml-3"
            alt="Nasan Logo"
            width="100"
            height="100"
          />
        </router-link>
      </div>

      <div class="md:ml-auto hidden md:block">
        <!-- Menu links here -->
        <ul
          id="menu"
          class="hidden fixed top-0 right-0 px-10 py-16 bottom-20 z-30 md:relative md:flex md:p-0 md:bg-transparent md:flex-row lg:-space-x-1 duration-700 divider-x divide-gray-700"
          dir="rtl"
        >
          <li class="flex justify-start items-center  "  >
            <router-link
              to="/categories"
              class="menu-item text-[1.2vw]"
              exactActiveClass="text-basic border-b-[6px] border-basic"
            >
              تصفح التصنيفات</router-link
            >
          </li>

          <li class="flex justify-start items-center ">
            <router-link
              to="/brows/channels"
              href="#"
              class="menu-item text-[1.2vw]"
              exactActiveClass="text-basic border-b-[6px] rounded-md border-basic"

            >
              القنوات
              <small
                class="text-white bg-red-600  rounded-md p-1 text-xs"
                >بث مباشر</small
              >
            </router-link>
          </li>
        </ul>

        <!-- This is used to open the menu on mobile devices -->
      </div>
    </div>
  </nav>
</template>

<script>
import AuthActions from "./shared/AuthActions.vue";
import SearchView from "./shared/SearchView.vue";
export default {
  components: { SearchView, AuthActions },

  name: "MobileView",
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {},
 
};
</script>

<style>
/* .bg-mobile{
    background-color: rgba(0, 0, 0, 0.1);
  } */

input[type="search"]::placeholder {
  text-align: right;
}
focus:input[type="search"] {
  outline: none;
  border: none;
  outline-width: 0;
}
.shadow-menu {
  background: linear-gradient(to top, rgb(21, 24, 43, 0) 0%, rgb(0, 0, 0, 100));
}

a:hover,a:active,a:focus {
  text-decoration: none;
  color: #9d2890;
}

.shimmer {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.1) 25%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.1) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.shimmer-box {
  background: rgba(255, 255, 255, 0.1);
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
